import { useLottie } from 'lottie-react';
import React from 'react';
import catAnimation from '../../../assets/animations/error.json';

export default function ErrorAnim() {
	return (
		<div className="flex flex-col mx-auto text-center">
			<div className="w-7/12 mx-auto">
				<ErrorAnimation />
			</div>
			<div>
				<h3 className="text-4xl font-bold dark:text-gray-200 text-gray-700">
					Apologies, An error has occured!
				</h3>
			</div>
		</div>
	);
}

export function ErrorAnimation() {
	const options = {
		animationData: catAnimation,
		loop: true,
		autoplay: true
	};

	const { View } = useLottie(options);

	return View;
}
